<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>

<script lang="ts" setup>
const { $api } = useNuxtApp();

const { user } = useUserSession();

if (user.value) {
  user.value.lastLogin = new Date();
  $api("/user", {
    method: "patch",
    body: {
      lastLogin: new Date(),
    },
  });
}

const colorMode = useColorMode();

// const color = computed(() =>
//   colorMode.value === "dark" ? "#111827" : "neutral-",
// );

useHead({
  meta: [
    { charset: "utf-8" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    // { key: "theme-color", name: "theme-color", content: color },
  ],
  link: [{ rel: "icon", href: "/favicon.ico" }],
  htmlAttrs: {
    lang: "en",
  },
});
</script>
